import { z } from "zod";

export const patchUserSchema = z.object({
  id: z.string().uuid(),
  group_id: z.string().uuid(),
  login_id: z.string(),
  name: z.string(),
  authority: z.number(),
}).strip();
export type patchUserType = z.infer<typeof patchUserSchema>;

export const setNewPasswordSchema = z.object({
  id: z.string().uuid(),
  password: z.string(),
});
export type setNewPasswordPayload = z.infer<typeof setNewPasswordSchema>;

export const putUserSchema = z.object({
  group_id: z.string().uuid(),
  login_id: z.string(),
  name: z.string(),
  authority: z.number(),
  password: z.string(),
}).strip();
export type putUserType = z.infer<typeof putUserSchema>;